import React from 'react';
import styled from 'styled-components';

import { layout, remCalc } from '@prisjakt/ui-base';
import { TitleSmallText } from '@prisjakt/ui/text/variants';
import { useAppContext } from '@prisjakt/ui-app-context';

export const SortedBy = () => {
  const { t } = useAppContext();
  return <SortCopy>{t('search', 'search.sorted-by-relevance')}</SortCopy>;
};

const SortCopy = styled(TitleSmallText)`
  align-self: center;
  margin-bottom: 0;
  margin-right: ${layout.measurements.spacing100};
  text-align: end;
  color: ${p => p.theme.text.tertiary};
  font-size: ${remCalc(12)};
`;
